<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'paymentAndVerifyReport')">
            <!-- 收付核销报表 -->
            <div slot="header" class="not-default-form pl16">
                <a-form :form="filterForm" layout="inline" >
                    <a-form-item label="日期">
                        <a-range-picker
                            v-decorator="['timeRange', {
                                initialValue: defaultValue,
                                rules: [
                                    { required: true, message: '请输入' },
                                    { validator: limitRange },
                                ]
                            }]"
                            showTime
                            :allow-clear="false"
                            :disabled-date="disabledDate"
                        />
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button :loading="searchLoading" type="primary" @click="getList">筛选</a-button>
                        <a-button :loading="searchLoading" @click="handleReset()">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card v-if="shopId && shopId != -1">
                <div slot="extra">
                    <a-button type="primary" v-if="getBtnByAuth('exportConfirmPayment')" @click="exportExcelConfirmPayment" :loading="exportLoading">导出确认收入表</a-button>
                    <a-button type="primary" v-if="getBtnByAuth('exportReceivable')" @click="exportExcelReceivable" :loading="exportLoading">导出待确认收入表</a-button>
                    <a-button @click="openExportModal2">导出记录</a-button>
<!--                    <a-button type="primary" @click="exportExcel" :loading="searchLoading">导出excel</a-button>-->
<!--                    <a-button @click="openExportModal">导出记录</a-button>-->
                </div>
                <div slot="title" class="text-primary">
                    {{this.shopName}}
                    <a-popover title="计算公式" placement="topRight">
                        <template slot="content">
                            <div>确认收入表：筛选日期范围内核销的单次卡、多次卡；分摊日在筛选日期范围内的期限卡；筛选日期内过期的所有票券；退款、退次的票。</div>
                            <div>待确认收入表：在筛选日期的结束时间点之前仍处于有效期的「未核销单次卡、多次卡中未核销的次数部分、期限卡未确认收入部分」的记录。</div>
                        </template>
                        <a-icon type="info-circle" />
                    </a-popover>
                </div>
                <!-- <a-table
                bordered
                :dataSource="[]"
                :columns="columns"
                :pagination="false"
                :rowKey="(record,index) => index"
                :scroll="{y: 440}"
                :loading="searchLoading"
                >
                </a-table> -->

                <a-empty>
                    <span slot="description" class="font-big22">请直接导出</span>
                </a-empty>
            </a-card>
            <a-empty v-else>
                <span slot="description" class="font-big22">请切换到各门店查看</span>
            </a-empty>
            <report-export-modal ref="reportExportModal" :exportType="31"></report-export-modal>
            <report-export-modal ref="reportExportModal2" :exportType="40"></report-export-modal>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import moment from 'moment';
    import { mapGetters } from 'vuex';
    export default {
        name: 'financialIndex',
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: '',
                    dataIndex: 'field0',
                    colSpan: 2,
                    align: 'center',
                    customRender: (text, row, index) => {
                        return {
                            children: text,
                            attrs: {
                                colSpan: index === 0 ? 2 : 1,
                                rowSpan: row.rowSpan
                            },
                        };
                    },
                },
                {
                    title: '',
                    dataIndex: 'field1',
                    colSpan: 0,
                    customRender: (text, row, index) => {
                        return {
                            children: text,
                            attrs: {
                                colSpan: index === 0 ? 0 : 1,
                            },
                        };
                    },
                },
                {
                    title: '收入/元',
                    dataIndex: 'field2',
                },
                {
                    title: '收入同比',
                    dataIndex: 'field3',
                },
                {
                    title: '订单量',
                    dataIndex: 'field4',
                },
                {
                    title: '平均每单金额/元',
                    dataIndex: 'field5',
                },
                {
                    title: '人均消费金额/元',
                    dataIndex: 'field6',
                },


            ];
            return {
                columns,
                dataSource: [
                    {
                        field0: '汇总',
                        field1: '汇总',
                        field2: 23456.78,
                        field3: '67.89%',
                        field4: 4568,
                        field5: 9874.89,
                        field6: 2341.54,
                    },
                    {
                        field0: '票务',
                        field1: '票务合计',
                        field2: 23456.78,
                        field3: '67.89%',
                        field4: 4568,
                        field5: 9874.89,
                        field6: 2341.54,
                        rowSpan: 2,
                    },
                    {
                        field0: '票务',
                        field1: '收银台',
                        field2: 23456.78,
                        field3: '67.89%',
                        field4: 4568,
                        field5: 9874.89,
                        field6: 2341.54,
                        rowSpan: 0,
                    },
                    {
                        field0: '餐饮',
                        field1: '餐饮合计',
                        field2: 23456.78,
                        field3: '67.89%',
                        field4: 4568,
                        field5: 9874.89,
                        field6: 2341.54,
                        rowSpan: 2,
                    },
                    {
                        field0: '餐饮',
                        field1: '咔咔美味村',
                        field2: 23456.78,
                        field3: '67.89%',
                        field4: 4568,
                        field5: 9874.89,
                        field6: 2341.54,
                        rowSpan: 0,
                    }
                ],
                filterForm: this.$form.createForm(this),
                defaultValue: [],
                countData: {},
                searchLoading: false,
                exportLoading: false
            };
        },
        beforeCreate() {},
        watch: {
            shopName(val,oVal) {
                // this.getList();
            },
        },
        computed: {
            ...mapGetters(['shopName','shopId'])
        },
        methods: {
            limitRange(rule, value, callback) {
                if (value[1].diff(value[0], "days") > 366) {
                    callback('所选范围不能超过366天');
                    return;
                }
                callback();
            },
            disabledDate(current) {
                return current && current > moment().subtract(1, 'day').endOf('day');
            },
            // 重置筛选
            handleReset() {
                this.filterForm.resetFields();
                this.getList();
            },
            //获取列表
            getList() {
                return
                if(!Boolean(this.shopId) || this.searchLoading) {
                    return false;
                }
                this.filterForm.validateFields((errors, values) => {
                    if (errors) return;
                    this.searchLoading = true;
                    this.$api.financial.financeList({ query: {
                        shopId: this.shopId,
                        startTime: values.timeRange[0].format('YYYY-MM-DD HH:mm:ss'),
                        endTime: values.timeRange[1].format('YYYY-MM-DD HH:mm:ss')
                    } }).then(res => {
                        this.searchLoading = false;
                        this.dataSource = [];
                        let names = ['pos','balance','cash','manual','scanner','systemOperate'];
                        let cashierId = [];
                        res.forEach(item => {
                            let obj = {};
                            names.forEach(o => {
                                obj = Object.assign(obj,{
                                    [o + 'deliverDiff']: item[o].deliverDiff === null ? '/' : item[o].deliverDiff === 0 ? 0 : item[o].deliverDiff.toFixed(2),
                                    [o + 'deliverReal']: item[o].deliverReal === null ? '/' : item[o].deliverReal === 0 ? 0 : item[o].deliverReal.toFixed(2),
                                    [o + 'deliverShould']: item[o].deliverShould === null ? '/' : item[o].deliverShould === 0 ? 0 : item[o].deliverShould.toFixed(2),
                                    [o + 'incomeAfterDiscount']: item[o].incomeAfterDiscount === null ? '/' : item[o].incomeAfterDiscount === 0 ? 0 : item[o].incomeAfterDiscount.toFixed(2),
                                    [o + 'incomeBeforeDiscount']: item[o].incomeBeforeDiscount === null ? '/' : item[o].incomeBeforeDiscount === 0 ? 0 : item[o].incomeBeforeDiscount.toFixed(2),
                                    [o + 'refundNotToday']: item[o].refundNotToday === null ? '/' : item[o].refundNotToday === 0 ? 0 : item[o].refundNotToday.toFixed(2),
                                    [o + 'refundToday']: item[o].refundToday === null ? '/' : item[o].refundToday === 0 ? 0 : item[o].refundToday.toFixed(2),
                                })
                            })
                            item.cashierId ? cashierId.push(item.cashierId) : cashierId.push('-1');
                            obj = Object.assign(obj,{
                                cashier: item.cashier,
                                cashierId: item.cashierId || cashierId.join(','),
                                platformId: item.platformId,
                                platformName: item.platformName,
                                recordDate: this.filterForm.getFieldValue('startTime').format('YYYY-MM-DD')
                            })
                            this.dataSource.push(obj)
                        })
                    }).catch(err => {
                        this.searchLoading = false;
                    });
                })
            },

            // 导出excel
            exportExcel() {
                this.filterForm.validateFields((err, values) => {
                    if (err) return;
                    values.startTime = values.startTime ? values.startTime.format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
                    this.searchLoading = true
                    this.$api.financial.refundExport({ query: {
                        shopId: this.shopId,
                        date: values.startTime
                    } }).then(res => {
                        this.openExportModal();
                        this.searchLoading = false;

                    }).catch(err => {
                        this.searchLoading = false;
                    });
                });
            },
            /**
             * @func openExportModal 打开导出记录弹窗
             */
            openExportModal() {
                this.$refs.reportExportModal.open();
            },
            openExportModal2() {
                this.$refs.reportExportModal2.open();
            },
            // 导出确认收入表
            exportExcelConfirmPayment() {
                this.filterForm.validateFields((err, values) => {
                    if (err) return;
                    this.exportLoading = true
                    this.$api.financial.exportExcelConfirmPayment({
                        body: {
                            // shopId: this.shopId,
                            maxTime: values.timeRange[1].format('YYYY-MM-DD HH:mm:ss'),
                            minTime: values.timeRange[0].format('YYYY-MM-DD HH:mm:ss')
                        }
                    }).then(res => {
                        this.openExportModal2();
                        this.exportLoading = false;
                    }).catch(err => {
                        this.exportLoading = false;
                    });
                });
            },
            // 导出确认收入表
            exportExcelReceivable() {
                this.filterForm.validateFields((err, values) => {
                    if (err) return;
                    this.exportLoading = true
                    this.$api.financial.exportExcelReceivable({
                        body: {
                            // shopId: this.shopId,
                            maxTime: values.timeRange[1].format('YYYY-MM-DD HH:mm:ss'),
                            minTime: values.timeRange[0].format('YYYY-MM-DD HH:mm:ss')
                        }
                    }).then(res => {
                        this.openExportModal2();
                        this.exportLoading = false;
                    }).catch(err => {
                        this.exportLoading = false;
                    });
                });
            },
            /**
             * @count 财务统计
             */
            count(startTime) {
                if(!Boolean(this.shopId)) {
                    return false;
                }
                this.$api.financial.count({
                    params: {
                        shopId: this.shopId,
                        date: startTime
                    }
                }).then(res => {
                    this.countData = res;
                });
            },
        },
        created() {
            this.defaultValue = [moment({day: 1, hour: 0, minute: 0, second: 0}), moment({hour: 23, minute: 59, second: 59}).subtract(1, "day")]
        },
        mounted() {
            // this.getList();
        }
    };
</script>
<style lang="scss">
    .my-divider {
        margin: 8px 0!important;
    }
</style>
